import { gql } from '@urql/core';
import Link from 'next/link';
import {
    Espin_Event_Ticket_Type_Enum,
    Espin_Role_Enum,
    EventTicketCardFragment,
} from '../../../generated/spin-graphql';
import { capitalizeFirstLetter } from '../../../shared/shared.utils';
import { useAppState } from '../../../client/providers/AppProvider';
import { useMemo } from 'react';

gql`
    fragment EventTicketCard on espin_event_ticket {
        id
        ticket_type
        description
        game {
            game_definition
            name
        }
        price_temp
        event {
            slug
        }
    }
`;
type Props = {
    selected: boolean;
    ticket: EventTicketCardFragment;
    onClick?: () => void;
    registrationId?: string;
};

export const EventTicketCard: React.FC<Props> = ({ selected, ticket, onClick, registrationId }) => {
    const { user } = useAppState();
    const formatter = Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    const price: string | null = ticket.price_temp ? formatter.format(ticket.price_temp) : null;

    const disabled = useMemo(() => {
        return (
            !!registrationId ||
            (user?.role === Espin_Role_Enum.EspinHighschoolUser &&
                ticket.ticket_type !== Espin_Event_Ticket_Type_Enum.Team)
        );
    }, [registrationId, user?.role, ticket.ticket_type]);

    return (
        <button
            disabled={disabled}
            className={`ticket${selected ? ' active' : ''}${disabled ? ' disabled' : ''}`}
            onClick={!!registrationId ? () => {} : onClick}
        >
            {!!registrationId && (
                <div className="already-registered">
                    <p className="registered">Registered</p>
                    <Link href={`/events/${ticket.event.slug}/confirmation/${registrationId}`}>
                        <a className="registered-link">{`View Registration`}</a>
                    </Link>
                </div>
            )}
            <div className="title-container">
                <h2 className="ticket-title">
                    {capitalizeFirstLetter(ticket.ticket_type)}
                    {' Ticket - '}
                    {ticket.game.name}
                </h2>
                <p className="ticket-price">{price}</p>
            </div>
            {!registrationId && <p className="ticket-description">{ticket.description}</p>}
        </button>
    );
};
